import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "How does AI grading eliminate human error?",
    a: "Every card is evaluated by the same computer-vision model against millions of reference samples. The model doesn't get tired, doesn't play favorites, and doesn't drift day-to-day. Two identical cards submitted a year apart receive the same grade.",
  },
  {
    q: "How is the final grade calculated?",
    a: "We independently score Centering, Corners, Edges, and Surface from multi-angle 40MP scans. Those four subgrades are combined via a deterministic rubric to produce the final overall grade (1–10, with half-points and Gem Mint+).",
  },
  {
    q: "Can I see the subgrades?",
    a: "Yes. Standard, Express, and Premium tiers include a full digital report with the four subgrade values, scan images, and an explanation of any points deducted.",
  },
  {
    q: "What happens if I disagree with a grade?",
    a: "Because the AI is deterministic, a re-grade would produce the same result unless the card was physically altered. We offer a review where a second model configuration re-scans the card end-to-end.",
  },
  {
    q: "How fast is turnaround?",
    a: "From 48 hours (Premium) up to 45 business days (Economy). Turnaround is measured from the moment your cards arrive at our facility.",
  },
  {
    q: "Is my card insured in transit?",
    a: "Yes. Standard and above include insured return shipping based on your declared value. You are responsible for insuring the inbound leg.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <div className="chip mb-6 mx-auto">FAQ</div>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[1.05]">
            Questions, answered.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {ITEMS.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-xl px-5 md:px-6 mb-3 bg-black/30"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-left text-base md:text-lg font-semibold text-white hover:text-brand hover:no-underline py-5">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-sm md:text-base leading-relaxed pb-5">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
